import AutocompleteModule from './autocomplete.module'

export default AutocompleteModule
